/* TTS SaaS Consumer - Main Entry */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import ElementPlus from 'element-plus';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import 'element-plus/dist/index.css';
import '@tts-saas/ui-tokens';
import App from './App.vue';
import router from './router';
import messages from './i18n/messages';

const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

const i18n = createI18n({
  legacy: false,
  locale: 'vi',
  fallbackLocale: 'en',
  messages,
});

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(ElementPlus);
app.mount('#app');
